import {create} from "zustand";
import { GetHotelListItemDto } from '@/features/hotels/types/hotels-dto';
import { ApiConfig } from '@/config/api.config';
import {RequestHeaders} from "@/@types/auth.types.ts";

type HotelStorageType = {
    selectedHotel: GetHotelListItemDto,
    setSelectedHotel: ( hotel: HotelStorageType['selectedHotel'] ) => void;
};

const defaultState = {
    id: '',
    name: '',
}

export const useHotelStorage = create<HotelStorageType>((set) => ({
    selectedHotel: {...defaultState},
    setSelectedHotel: (newHotel) => {
        ApiConfig.axiosInstance.defaults.headers[RequestHeaders.HotelId] = newHotel.id;
        set({ selectedHotel: newHotel });
    },   
}));